import { BCMSDefaultModel, BCMSRecord, useGlobalController, Workflow } from "@bcm-dev/bcms-vite";
import { Bill, Biller } from "model";

import AddBillerPage from "compid/pages/AddBillerPage";

// Steps of the workflow
const steps = {
    "/addBiller" : <AddBillerPage />
};

/**
 * @function AddBillerLongWorkflow
 * @returns {React.Component}
 * @description The main component for the add biller long form workflow
 * @example
 * <AddBillerLongWorkflow />'
 */
export default function AddBillerLongWorkflow(props) {
    // Initalize a global controller instance
    const controller = useGlobalController();
    // Get the default value of the workflow
    const value = getDefaultBiller(controller);

    const constructor = value => {
        const { biller, bill } = getDefaultBiller(controller);
        const { biller: billerValues, bill: billValues } = value;

        return {
            biller: Biller.init({ ...biller.record, ...billerValues }),
            bill: Bill.init({ ...bill.record, ...billValues })
        };
    };

    return <Workflow value={ value } steps={ Object.values(steps) } constructor={ constructor } />
}

/**
 * @function getWorkflowSteps
 * @returns {OBJECT}
 * @description Get the steps of the workflow
 */
export const getWorkflowSteps = () => steps;

/**
 * @function getDefaultBiller
 * @param {globalController} controller - Instance of a global controller
 * @returns {OBJECT}
 * @description Returns the default workflow state
 */
export const getDefaultBiller = controller => {
    // Initalize model types that are required
    BCMSRecord.globalControllerFor([ Biller, Bill ], controller);
    // Create a new biller with default data not added through the workflow
    const { billerLogo, billerPaymentType, billerEBillStatus, billerConfirmInfo } = BCMSDefaultModel.biller().record;

    const biller = Biller.init({ billerLogo, billerPaymentType, billerEBillStatus, billerConfirmInfo });
    const bill = BCMSDefaultModel.bill();

    bill.id = Bill.nextID();
    biller.id = Biller.nextID();

    return { biller, bill };
};